export default "__VITE_ASSET__BKluhDED__"